import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ProblemSolution from './components/ProblemSolution';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import ComparisonCTA from './components/ComparisonCTA';
import SEOArticles from './components/SEOArticles';
import FAQ from './components/FAQ';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://itaobuy.beauty';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': 'ItaobuySpreadsheet',
  'url': siteUrl,
  'description': 'A powerful spreadsheet-based shopping system for sourcing products from China faster, cheaper, and more efficiently.',
  'potentialAction': {
    '@type': 'SearchAction',
    'target': `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ProblemSolution />
        <Features />
        <HowItWorks />
        <ComparisonCTA />
        <SEOArticles />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}